module.exports = __webpack_public_path__ + "static/img/index_banner_02.6eeb3076.png";